'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { clearFilters, fetchTrials, selectTrials, selectTrialsError, selectTrialsFilters, selectTrialsLoading, selectTrialsSummary, setFilters } from '../store';
import type { TrialListFilters, TrialTenant } from '../types';
interface UseTrialsListResult {
  trials: TrialTenant[];
  filteredTrials: TrialTenant[];
  summary: ReturnType<typeof selectTrialsSummary>;
  filters: TrialListFilters;
  loading: boolean;
  error: string | null;
  isFiltering: boolean;
  refresh: () => void;
  updateFilters: (patch: Partial<TrialListFilters>) => void;
  resetFilters: () => void;
}
const aplicarFiltros = (trials: TrialTenant[], filters: TrialListFilters): TrialTenant[] => {
  const buscaNormalizada = filters.busca.trim().toLowerCase();
  return trials.filter(trial => {
    if (filters.status.length > 0 && !filters.status.includes(trial.status)) {
      return false;
    }
    if (buscaNormalizada && !trial.tenantNome.toLowerCase().includes(buscaNormalizada)) {
      return false;
    }
    if (filters.dataExpiracaoInicio && trial.dataExpiracao.slice(0, 10) < filters.dataExpiracaoInicio) {
      return false;
    }
    if (filters.dataExpiracaoFim && trial.dataExpiracao.slice(0, 10) > filters.dataExpiracaoFim) {
      return false;
    }
    return true;
  });
};
export function useTrialsList() {
  const $ = _c(28);
  const dispatch = useAppDispatch();
  const trials = useAppSelector(selectTrials);
  const loading = useAppSelector(selectTrialsLoading);
  const error = useAppSelector(selectTrialsError);
  const summary = useAppSelector(selectTrialsSummary);
  const filters = useAppSelector(selectTrialsFilters);
  let t0;
  let t1;
  if ($[0] !== dispatch) {
    t0 = () => {
      dispatch(fetchTrials());
    };
    t1 = [dispatch];
    $[0] = dispatch;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== filters || $[4] !== trials) {
    t2 = aplicarFiltros(trials, filters);
    $[3] = filters;
    $[4] = trials;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const filteredTrials = t2;
  let t3;
  if ($[6] !== filters.busca || $[7] !== filters.dataExpiracaoFim || $[8] !== filters.dataExpiracaoInicio || $[9] !== filters.status.length) {
    t3 = filters.status.length > 0 || filters.busca.trim().length > 0 || filters.dataExpiracaoInicio !== null || filters.dataExpiracaoFim !== null;
    $[6] = filters.busca;
    $[7] = filters.dataExpiracaoFim;
    $[8] = filters.dataExpiracaoInicio;
    $[9] = filters.status.length;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const isFiltering = t3;
  let t4;
  if ($[11] !== dispatch) {
    t4 = () => {
      dispatch(fetchTrials());
    };
    $[11] = dispatch;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const refresh = t4;
  let t5;
  if ($[13] !== dispatch) {
    t5 = patch => {
      dispatch(setFilters(patch));
    };
    $[13] = dispatch;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const updateFilters = t5;
  let t6;
  if ($[15] !== dispatch) {
    t6 = () => {
      dispatch(clearFilters());
    };
    $[15] = dispatch;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const resetFilters = t6;
  let t7;
  if ($[17] !== error || $[18] !== filteredTrials || $[19] !== filters || $[20] !== isFiltering || $[21] !== loading || $[22] !== refresh || $[23] !== resetFilters || $[24] !== summary || $[25] !== trials || $[26] !== updateFilters) {
    t7 = {
      trials,
      filteredTrials,
      summary,
      filters,
      loading,
      error,
      isFiltering,
      refresh,
      updateFilters,
      resetFilters
    };
    $[17] = error;
    $[18] = filteredTrials;
    $[19] = filters;
    $[20] = isFiltering;
    $[21] = loading;
    $[22] = refresh;
    $[23] = resetFilters;
    $[24] = summary;
    $[25] = trials;
    $[26] = updateFilters;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
}